import { atom } from "recoil";

const localStorageEffect = key => ({ setSelf, onSet }) => {
    const savedValue = localStorage.getItem(key)
    if (savedValue !== null) {
        setSelf(savedValue);
    }

    onSet((newValue, _, isReset) => {
        isReset
            ? localStorage.removeItem(key)
            : localStorage.setItem(key, newValue);
    });
};

export const historyRouteState = atom({
    key: 'historyRoute',
    default: null
})

export const currentUrlState = atom({
    key: 'currentUrl',
    default: '',
    effects_UNSTABLE: [
        localStorageEffect('currentUrl')
    ],
})